<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="relative">
  <div class="vx-navbar-wrapper">
    <vs-navbar class="vx-navbar navbar-custom" :color="navbarColor" :class="classObj">

      <!-- SM - OPEN SIDEBAR BUTTON -->
      <feather-icon class="sm:inline-flex xl:hidden cursor-pointer mr-1" icon="MenuIcon" @click.stop="showSidebar"></feather-icon>
      <div class="font-bold ml-2">{{pageTitle}}</div>
      <vs-spacer></vs-spacer>
      <vs-dropdown vs-custom-content vs-trigger-click class="the-navbar__user-meta flex items-center ml-4 cursor-pointer">
        <div class="con-vs-avatar mr-6">
          <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_nl.svg" v-if="lang==='NL'">
          <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_de.svg" v-if="lang==='DE'">
          <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_be.svg" v-if="lang==='BE'">
          <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_fr.svg" v-if="lang==='FR'">
          <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_en.svg" v-if="lang==='EN'">
        </div>
        <div class="text-right leading-tight hidden sm:block">
          <p class="font-semibold" v-if="lang==='NL'">Nederlands</p>
          <p class="font-semibold" v-if="lang==='DE'">Deutch</p>
          <p class="font-semibold" v-if="lang==='BE'"> Belgium</p>
          <p class="font-semibold" v-if="lang==='FR'"> France</p>
          <p class="font-semibold" v-if="lang==='EN'"> English</p>
        </div>

        <vs-dropdown-menu class="vx-navbar-dropdown">
          <ul style="min-width: 9rem">
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center" @click="setLanguage('NL')">
              <div class="con-vs-avatar mr-6">
                <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_nl.svg">
              </div>
              <div class="text-right leading-tight hidden sm:block">
                <p class="font-semibold">Nederlands</p>
              </div>
            </li>
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center" @click="setLanguage('DE')">
              <div class="con-vs-avatar mr-6">
                <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_de.svg">
              </div>
              <div class="text-right leading-tight hidden sm:block">
                <p class="font-semibold">Deutsch</p>
              </div>
            </li>
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center" @click="setLanguage('BE')">
              <div class="con-vs-avatar mr-6">
                <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_be.svg">
              </div>
              <div class="text-right leading-tight hidden sm:block">
                <p class="font-semibold">Belgium</p>
              </div>
            </li>
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center" @click="setLanguage('FR')">
              <div class="con-vs-avatar mr-6">
                <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_fr.svg">
              </div>
              <div class="text-right leading-tight hidden sm:block">
                <p class="font-semibold">France</p>
              </div>
            </li>
            <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white items-center" @click="setLanguage('EN')">
              <div class="con-vs-avatar mr-6">
                <img class="con-img vs-avatar--con-img" src="../../assets/flags/flag_en.svg">
              </div>
              <div class="text-right leading-tight hidden sm:block">
                <p class="font-semibold">English</p>
              </div>
            </li>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
      <!-- USER META -->
      <vs-dropdown vs-custom-content vs-trigger-click class="the-navbar__user-meta flex items-center ml-4 cursor-pointer">
        <div class="text-right leading-tight hidden sm:block">
          <p class="font-semibold">{{ user.name }}</p>
          <small>Available</small>
        </div>
          <div class="con-img ml-3">
            <avatar :name="user.name"></avatar>
          </div>
          <vs-dropdown-menu class="vx-navbar-dropdown">
            <ul style="min-width: 9rem">
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/account/login')">
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"></feather-icon>
                  <span class="ml-2">Logout</span>
              </li>
            </ul>
          </vs-dropdown-menu>
      </vs-dropdown>

    </vs-navbar>
  </div>
</div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import draggable from 'vuedraggable'
import {mapMutations, mapState} from "vuex";
import Avatar from "../../components/Avatar/Avatar";

export default {
    name: "the-navbar",
    props: {
        navbarColor: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    watch: {
        '$route'() {
            if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            lang: state => state.auth.lang
        }),
        // HELPER
        sidebarWidth() {
            return this.$store.state.sidebarWidth;
        },
        breakpoint() {
            return this.$store.state.breakpoint;
        },

        // NAVBAR STYLE
        classObj() {
            if (this.sidebarWidth === "default") return "navbar-default"
            else if (this.sidebarWidth === "reduced") return "navbar-reduced"
            else if (this.sidebarWidth) return "navbar-full"
        },
        pageTitle(){
            return this.$route.meta.title;
        }
    },
    methods: {
      ...mapMutations('auth', [
              'setLanguage'
      ]),
        showSidebar() {
            this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
        },
        actionClicked(item) {
            // e.stopPropogation();
            this.$store.dispatch('updateStarredPage', { index: item.index, val: !item.highlightAction })
        },
    },
    directives: {
        'click-outside': {
            bind: function(el, binding) {
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler
                document.addEventListener('click', handler)
            },

            unbind: function(el) {
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    },
    components: {
        Avatar,
        VxAutoSuggest,
        VuePerfectScrollbar,
        draggable
    },
}
</script>
